import { decodeJwt } from "@/utils/decode-jwt.js";

const state = {
  isThermal: false,
  isBobbieContext: false,
  bobbieToken: null,
  isInIFrameContext: false,
  isEmployee: false,
};

const getters = {
  activeUserIsEmployee: (state) => state.isEmployee,
};

const actions = {};

const mutations = {
  setIsThermal(state, value) {
    state.isThermal = value;
  },
  setIsBobbieContext(state, value) {
    state.isBobbieContext = value;
  },
  setBobbieToken(state, token) {
    state.bobbieToken = token;
  },
  setIsInIFrameContext(state, value) {
    state.isInIFrameContext = value;
  },
  setIsEmployee(state, value) {
    state.isEmployee = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
